import React from 'react';
import logo from 'assets/img/pebsteel.png';

// Shown while redux-persist rehydrates state from IndexedDB. Must stay free of
// redux imports — it renders before the store is available, so the
// server-driven logo (Logo.js) can't be used here.
const AppSplash = () => (
  <div className="tw-fixed tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-bg-[var(--surface-ground)]">
    <img src={logo} alt="Portal" className="tw-h-12" />
    <div className="tw-h-6 tw-w-6 tw-animate-spin tw-rounded-xl tw-border-2 tw-border-solid tw-border-slate-300 tw-border-t-blue-600" />
  </div>
);

export default AppSplash;
